module.exports = __webpack_public_path__ + "img/yinhao.fab050e1.png";